import { useV2ListQuestionnaireSectionsForQuestionnaireQuery } from "@generated";
import type { Section } from "../types";

export const useSectionsList = (questionnaireId: string) => {
  const { data, isLoading, isFetching, refetch } =
    useV2ListQuestionnaireSectionsForQuestionnaireQuery(
      {
        // Sections are hard-deleted (no `active` column), so no active filter.
        questionnaireId: Number(questionnaireId),
        page: { size: 200 },
      },
      { refetchOnMountOrArgChange: true }
    );

  const rows: Section[] = (data?.data ?? []).map((s: any) => ({
    id: String(s.id),
    name: s.attributes?.name ?? "",
    expression: s.attributes?.expression ?? "",
    introduction: s.attributes?.introduction ?? "",
    position: s.attributes?.position ?? 0,
  }));

  return { rows, isLoading, isFetching, refetch };
};

export default useSectionsList;
